export default {
  TEMPLATES_MODAL: 'templates_modal',
  MULTIPLE_INVITE_MODAL: 'invite_multiple_teammates_open',
  INVITE_BY_EMAIL_MODAL: 'invite_teammates_by_email_open',
  ADD_USER_MODAL: 'invite_by_settings',
  ADD_TEAMMATE_MODAL: 'add_teammate_open',
  ADD_GROUP_WORKSPACE_MODAL: 'add_group_open',
  INVITE_BY_WORKSPACE_MODAL: 'invite_by_workspace',
  INVITE_BY_GROUP_WORKSPACE_MODAL: 'invite_by_group_workspace',
  FROM_CONNECT_TO_CAL: 'from_connect_to_cal',
  CREATE_ACTION_ITEM_MODAL: 'create_action_item',
  WORK_EMAIL_ERROR: 'work_email_error',
  RECOGNITION_REQUEST: 'recognition_request',
  REVIEW_STARTED_MODAL: 'review_started_successful',
  SELF_REVIEW_STARTED_MODAL: 'self_review_started_successful',
  PEER_REVIEW_COMPLETED: 'peer_review_completed',
  PEER_SELF_REVIEW_COMPLETED: 'peer_self_review_completed',
  PERFORMANCE_REVIEW_SELF_REVIEW_COMPLETED: 'performance_review_self_review_completed',
  PERFORMANCE_REVIEW_MANAGER_REVIEW_COMPLETED: 'performance_review_manager_review_completed',
  PERFORMANCE_REVIEW_COMPILATION_COMPLETED: 'performance_review_compilation_completed',
  PERFORMANCE_REVIEW_SHARED: 'performance_review_shared',
  COMPILER_REVIEW_COMPLETED: 'compiler_review_completed',
  HIDE_KUDOS_CARD: 'hide_kudos_card',
  TRACK_FINISHED_ONBOARDING: 'track_finished_onboarding',
  POST_SLACK_OAUTH: 'post_slack_oath',
  SHOW: 'show',
  CALLBACK_URL: 'callback_url',
  SLUG: 'slug',
  STEP: 'step',
  SELECTED_DATE: 'selectedDate',

  Api: {
    TYPE: 'type',
    DISCUSSION_TOPICS: 'discussion_topics',
    ACTION_ITEMS: 'action_items',
    GOAL_ID: 'goal_id',
    LIMIT: 'limit',
    OFFSET: 'offset',
    WORKSPACE_ID: 'workspace_id',
    DATA_FORMAT: 'data_format',
    JSONAPI: 'jsonapi',
    MEETING_ITEM_ATTACHMENT_ID: 'meetingItemAttachmentId',
    SHOW_PREVIEW: 'showPreview',
    WORKSPACE_ITEM_ID: 'workspaceItemId',
    CONTEXT: 'context',
    COMPLETED: 'completed',
    COMPLETED_SINCE_OR_UNCOMPLETED: 'completed_since_or_uncompleted',
    FILTER_BY: 'filter_by',
    COMPLETED_SINCE: 'completed_since',
    ASSIGNED_TO: 'assigned_to',
    ASSIGNEE_ID: 'assignee_id',
    CREATOR_ID: 'creator_id',
    RECEIVER_ID: 'receiver_id',
    TEMPLATE_TYPE: 'templateType',
    REVIEW_TEMPLATE_SLUG: 'reviewTemplateSlug',
  },
};
